export const ROUND_TRIP = "ROUND_TRIP";
export const ONE_WAY = "ONE_WAY";
export const MULTI_CITY = "MULTI_CITY";